import Attachment from '../company/attachment.entity';

export default class AppletSubgroups {
  public active = false;

  public attachments: Array<Attachment> = [];

  public canValidImage = false;

  public description = '';

  public id = '';

  public orderNumber = 0;

  public system = false;

  public title = '';

  public type = '';

  public appletSubgroupId = '';

  public isCustom: boolean;

  public appletProfileId: string;

  public appletSubgroupTypeId: string;

  public canValidateQRCodeCRLV: boolean;

  public questionGroups: any[];

  constructor(data: any = {}) {
    this.active = data.active ?? false;
    this.canValidImage = data.can_valid_image || false;
    this.description = data.description || '';
    this.id = data.id || '';
    this.orderNumber = data.order_number || 0;
    this.system = data.system || false;
    this.title = data.title || '';
    this.type = data.type || '';
    this.appletSubgroupId = data.applet_subgroup_id || '';
    this.isCustom = data.is_custom || false;
    this.attachments = data.attachments
      ? data.attachments.map((attachment: Attachment) => new Attachment(attachment))
      : [];
    this.appletProfileId = data.applet_profile_id || '';
    this.appletSubgroupTypeId = data.applet_subgroup_type_id || '';
    this.canValidateQRCodeCRLV = data.can_validate_qr_code_crlv ?? false;
    this.questionGroups = data.question_groups || [];
  }
}
